import React from 'react';
import { DashboardControl } from 'devexpress-dashboard';
import { localStorageService } from '../../services/localstorage-service';
import { UserRoleType } from '../../utils/user-role-type';
import { apiconst } from '../../utils/app-const';
import { DashboardPanelExtension } from 'devexpress-dashboard/common';
import { authenticationService } from '../../services/AuthService'
import { webDashboardService } from '../../services/WebDashboardService'

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.dashboardRef = React.createRef();
        this.state = {
            permission: 'Viewer',
            dashboardId: 0
        }
    }
    dashboardChanged = async (e) => {
        let workingMode;
        if (e.name === "dashboardId" && e.value === "0") {
            if (this.dashboardControl) {
                this.dashboardControl.switchToViewer();
            }
        }
        if (e.name === "dashboardId" && e.value > "0") {
            workingMode = await webDashboardService.GetWorkingMode(e.value);
            if (workingMode === 'Viewer') {
                this.dashboardControl.switchToViewer();
            }
            if (workingMode === 'Designer') {
                this.dashboardControl.switchToDesigner();
            }
        }
        this.setState({
            permission: workingMode ? workingMode : 'Viewer',
            dashboardId: e.value
        });
    };

    onBeforeDashboardRender = (a) => {
    };

    loadDashboards = () => {
        const userRole = localStorageService.getUserRoleType();
        const currentDate = new Date();
        this.setState({
            permission: this.verifyWorkingMode(userRole?.split(','))
        });

        this.dashboardControl = new DashboardControl(this.dashboardRef.current, {
            // Specifies the URL where the Web Dashboard's server side is hosted.
            endpoint: apiconst.ENDPOINT + apiconst.DASHBOARD,
            workingMode: this.state.permission,
            dashboardId: this.state.dashboardId,
            // workingMode: "ViewerOnly",
            MobileLayoutMode: 'Always',
            onBeforeRender: this.onBeforeDashboardRender,
            onOptionChanged: this.dashboardChanged,
            initialDashboardState: "{\"Items\":{\"comboBoxDashboardItem1\":{\"MasterFilterValues\":[[" + (currentDate.getMonth() + 1) + "]]}}}",
            ajaxRemoteService: {
                headers: {
                    'authorization': "bearer " + localStorageService.getAuthToken()
                }
            }
        });
        return this.dashboardControl;
    };

    verifyWorkingMode = (userRoles) => {
        let permission = "Viewer";
        if (!userRoles) {
            return permission;
        }
        debugger;
        userRoles.map(function (userRole) {

            if ((userRole === UserRoleType.EDITSTORE || userRole === UserRoleType.EDITCHAIN || userRole === UserRoleType.EDITCLUSTER) && (userRole === UserRoleType.VIEWSTORE || userRole === UserRoleType.VIEWCHAIN || userRole === UserRoleType.VIEWCLUSTER)) {
                permission = "Designer";
            }
            else if (userRole === UserRoleType.EDITSTORE || userRole === UserRoleType.EDITCHAIN || userRole === UserRoleType.EDITCLUSTER) {
                permission = "Designer";
            }
            else if (userRole === UserRoleType.VIEWSTORE || userRole === UserRoleType.VIEWCHAIN || userRole === UserRoleType.VIEWCLUSTER) {
                permission = "Viewer";
            }
        });
        return permission;
    }

    checkAuthentication = async () => {
        let isAuthented = await authenticationService.CheckAuthentication();
        if (!isAuthented) {
            localStorageService.clearStorage();
            window.location.reload(true);
        }
        else {
            if (this.dashboardControl === undefined) {
                const dashboardControl = this.loadDashboards();
                // The dashboardControl variable is the obtained DashboardControl instance.
                // var panelExtension = new DashboardPanelExtension(dashboardControl, { dashboardThumbnail: '/DashboardThumbnail/{0}.png' });
                var panelExtension = new DashboardPanelExtension(dashboardControl);
                dashboardControl.registerExtension(panelExtension);
                panelExtension.allowSwitchToDesigner(false);
                dashboardControl.render();
            }
        }
    }

    componentDidMount() {
        var a2hsBannerDiv = document.querySelector('.block__install');
        if (a2hsBannerDiv)
            a2hsBannerDiv.style.display = 'none';
        this.checkAuthentication();
    }

    componentWillUnmount() {
        if (this.dashboardControl)
            this.dashboardControl.dispose();
    }
    onEndUpdate(args) {
        console.log(args);
    }

    render() {
        return (
            <div>
                <div id="scrollviewdash">
                    <div ref={this.dashboardRef} style={{ width: '100%', height: '100%' }}></div>
                </div>
            </div>
        );
    }
}

export default Dashboard;